import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs';

import type { TapTraitAttribute } from './formatTapTraits';
import { formatTapTraits } from './formatTapTraits';

export type SiteTraits = {
	attributes: TapTraitAttribute[] | null;
};

export const preloadSiteTraits = async (): Promise<void> => {
	if (window.__SSR_SITE_TRAITS__) {
		return;
	}

	const { accessStatus, cloudId } = getPreloaderFnContext();

	if (accessStatus !== 'LICENSED_USE_ACCESS' && accessStatus !== 'LICENSED_ADMIN_ACCESS') {
		return;
	}

	if (!cloudId) {
		return;
	}

	const { tapContext } = getSSRRenderInputs();
	const attributes = formatTapTraits(tapContext?.site);

	if (!attributes) {
		return;
	}

	window.__SSR_SITE_TRAITS__ = { attributes };
};
